function setFzForBgtext(e) {
    const
            sizeForBgText = window.innerWidth,
            displayedText = e.innerText,
            styles = window.getComputedStyle(e, null),
            fz = styles.getPropertyValue('font-size'),
            ls = styles.getPropertyValue('letter-spacing'),
            fw = styles.getPropertyValue('font-weight');

    const dummy = document.createElement("div");
    dummy.innerText = displayedText;
    dummy.style.position = "absolute";
    dummy.style.visibility = "hidden";
    dummy.style.fontSize = fz;
    dummy.style.letterSpacing = ls;
    dummy.style.fontWeight = fw;
    document.body.insertBefore(dummy, document.body.firstChild);


    let elemWidth = dummy.clientWidth;

    while (elemWidth > sizeForBgText) {
        const newFz = parseFloat(window.getComputedStyle(dummy, null).getPropertyValue('font-size')) - 1;
        dummy.style.fontSize = newFz + 'px';
        elemWidth = dummy.clientWidth;
    }

    document.documentElement.style.setProperty(
        "--bgTextSize", dummy.style.fontSize
    );

    document.body.removeChild(dummy);

}


export const bgText = () => {
    const texts = document.querySelectorAll(".background-text");
    if (!!texts) {

        let maxLengthText = '';
        let elem = '';

        for (let index = 0; index < texts.length; index++) {
            const text = texts[index];

            if(text.offsetWidth > 0 || text.offsetHeight > 0){
                if(maxLengthText !== undefined && text.innerText.length > maxLengthText.length){
                    maxLengthText = text.innerText;
                    elem = text;
                } else if(maxLengthText === undefined){
                    maxLengthText = text.innerText;
                }
            }
        }
        if(!!elem){
            setFzForBgtext(elem);
        }
    }
};
